// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"11d3ad07","71":"0bfb2e90","249":"87e2e92c","791":"c2f0e909","886":"cb07703d"}[chunkId] + ".js";
};